import { DraftController } from './DraftController';
import { ThemeSelection } from './ThemeSelection';
import { StructureList } from './StructureList';
import { GraphicalVariables } from './GraphicalVariables';
import { DesignConfigurator } from './design-configuration/DesignConfigurator';

export function ThemeConfiguration() {
  return (
    <>
      <DraftController />
      <GraphicalVariables />
      <hr className="my-5 border-gray-300" />
      <DesignConfigurator />
      <hr className="my-5 border-gray-300" />
      <ThemeSelection />
      <hr className="my-5 border-gray-300" />
      <StructureList />
    </>
  );
}
